import { Component, OnInit, ViewChild, ElementRef, NgZone  } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder, NativeGeocoderResult, NativeGeocoderOptions } from '@ionic-native/native-geocoder/ngx';
import { ApiService } from '../services/api/api.service';
import { IonRadioGroup } from '@ionic/angular';
import { AlertService } from '../services/alert/alert.service';
import { ActivatedRoute } from '@angular/router';
import { RazorpayService } from '../services/razorpay/razorpay.service';

declare var google:any;

@Component({
  selector: 'app-shipping',
  templateUrl: './shipping.page.html',
  styleUrls: ['./shipping.page.scss'],
})
export class ShippingPage implements OnInit {

  @ViewChild('map',  {static: false}) mapElement: ElementRef;

  @ViewChild('radioGroup', {static: false}) radioGroup: IonRadioGroup
  map: any;
  address:string;
  lat: string;
  long: string;  
  autocomplete: { input: string; };
  autocompleteItems: any[];
  location: any;
  placeid: any;
  GoogleAutocomplete: any;
  selectedMethod: any = ''

  selectedRadioItem:any;
  customAlertOptions: any = {
    header: 'Packages',
    subHeader: 'Select your package',
    translucent: true
  };
  myCustomIcon:any = "../../assets/img/delivery-truck.png";

  data:any = {
    lat: '',
    lon: '',
    geo_address: '',
    first_name: '',
    last_name: '',
    phone_no: '',
    comments: '',
    payment: 'cod'
  }
  showList:any = false
  savedAddressList:any = []
  defaultAddress:any = ''
  sub:any

  priceDetails:any = ''
  payementTypeId:any = ''
  paymentTypes:any  []
  showDeliveryMessage:any = ''
  disableAddress: any = false
  constructor(public toastController: ToastController,
    public api: ApiService,
    private router: Router,
    private geolocation: Geolocation,
    private nativeGeocoder: NativeGeocoder,
    public zone: NgZone,
    public alert: AlertService,private route: ActivatedRoute,
    public razorPayService: RazorpayService
    ) {
      // this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
      // this.autocomplete = { input: '' };
      // this.autocompleteItems = [];

      this.sub = this.route.params.subscribe(params => {
        console.log(params)
        this.priceDetails = params
        localStorage.setItem("priceDetails",JSON.stringify(this.priceDetails))
      });
     }
  
  //LOAD THE MAP ONINIT.
  ngOnInit() {
    // this.loadMap();
    this.getPaymentTypes()
    this.getAddressData()
  }

  getPaymentTypes(){
    this.api.getPaymentTypes().subscribe((result:any) => {
        if(result.status == true){
          this.paymentTypes = []
          if(result.data.length > 0) {
            this.paymentTypes = result.data;
          }
        }
      },(err)=>{
        console.log(err)
      });
  }

  getAddressData(){
    this.zone.run(() => {
      try {  
        this.api.getAddressList().subscribe((result:any) => {
          if(result.status == true){
            if(result.data.length > 0){
              this.savedAddressList = []
              this.savedAddressList = result.data;
              for(let i = 0; i < this.savedAddressList.length;i++){
                this.savedAddressList[i].id = JSON.stringify(JSON.parse(this.savedAddressList[i].id))
                this.savedAddressList[i].checked = false
                this.savedAddressList[i].value = JSON.stringify(JSON.parse(this.savedAddressList[i].id))
              }
              this.defaultAddress = JSON.stringify(JSON.parse(this.savedAddressList[0].id))
            }
          }
        },(err)=>{
          console.log(err)
        });
      }
      catch (error) {
        console.error('Here is the error message', error);
      }
   })
  }

  radioGroupChange(event) {
    console.log("radioGroupChange",event.detail);
  }

  getDeliveryDate(value:any){
    if(value){
      var x = new Date(value)
      return x.toDateString().substring(4,15)
    }
    else {
      return ''
    }
  }

  radioSelect(event) {
    console.log("radioSelect",event.detail);
    this.selectedRadioItem = event.detail;
    // for(let i = 0; i < this.savedAddressList.length; i++){
    //   if(JSON.parse(this.selectedRadioItem.value) == this.savedAddressList[i].id){
    //     this.showDeliveryMessage = this.savedAddressList[i].zip_code_details
    //     break
    //   }
    //   else{
    //     this.showDeliveryMessage = ''
    //   }
    // }
  }

  checkMinOrder(){
    if(this.selectedMethod == "card" || this.selectedMethod == "cod"){
      let requestData:any = {
        "amount": JSON.parse(this.priceDetails.amount),
        "store_id": JSON.parse(localStorage.getItem('cart-store-id')),
      }
      this.api.minOrderCheck(requestData).subscribe((result:any) => {
        if(result.status == true){
          this.placeOrder()
        }
        else {
          this.alert.presentAlert('Alert','',result.message)
        }
      })
    }
    else{
      this.placeOrder()
    }
  }

//LOADING THE MAP HAS 2 PARTS.
loadMap() {
    
  //FIRST GET THE LOCATION FROM THE DEVICE.
  this.geolocation.getCurrentPosition().then((resp) => {
    let latLng = new google.maps.LatLng(resp.coords.latitude, resp.coords.longitude);
    // let mapOptions = {
    //   center: latLng,
    //   zoom: 15,
    //   mapTypeId: google.maps.MapTypeId.ROADMAP
    // } 
    
    //LOAD THE MAP WITH THE PREVIOUS VALUES AS PARAMETERS.
    this.getAddressFromCoords(resp.coords.latitude, resp.coords.longitude); 
    // this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions); 
    // this.map.addListener('tilesloaded', () => {
    //   console.log('accuracy',this.map, this.map.center.lat());
    //   this.getAddressFromCoords(this.map.center.lat(), this.map.center.lng())
    //   this.lat = this.map.center.lat()
    //   this.long = this.map.center.lng()
    // }); 
  }).catch((error) => {
    console.log('Error getting location', error);
  });
}


getAddressFromCoords(lattitude, longitude) {
  console.log("getAddressFromCoords "+lattitude+" "+longitude);
  let options: NativeGeocoderOptions = {
    useLocale: true,
    maxResults: 5    
  }; 
  this.nativeGeocoder.reverseGeocode(lattitude, longitude, options)
    .then((result: NativeGeocoderResult[]) => {
      this.address = "";
      let responseAddress = [];
      for (let [key, value] of Object.entries(result[0])) {
        if(value.length>0)
        responseAddress.push(value); 
      }
      responseAddress.reverse();
      for (let value of responseAddress) {
        this.address += value+", ";
      }
      this.address = this.address.slice(0, -2);
      this.autocomplete.input = this.address;
    })
    .catch((error: any) =>{ 
      this.address = "Address Not Available!";
    }); 
}

//FUNCTION SHOWING THE COORDINATES OF THE POINT AT THE CENTER OF THE MAP
ShowCords(){
  alert('lat' +this.lat+', long'+this.long )
}

//AUTOCOMPLETE, SIMPLY LOAD THE PLACE USING GOOGLE PREDICTIONS AND RETURNING THE ARRAY.
UpdateSearchResults(){
  if (this.autocomplete.input == '') {
    this.autocompleteItems = [];
    return;
  }
  this.GoogleAutocomplete.getPlacePredictions({ input: this.autocomplete.input },
  (predictions, status) => {
    this.autocompleteItems = [];
    this.zone.run(() => {
      predictions.forEach((prediction) => {
        this.autocompleteItems.push(prediction);
      });
      if(this.autocompleteItems.length > 0){
        this.showList = true
      }
    });
  });
}

//wE CALL THIS FROM EACH ITEM.
SelectSearchResult(item) {
  ///WE CAN CONFIGURE MORE COMPLEX FUNCTIONS SUCH AS UPLOAD DATA TO FIRESTORE OR LINK IT TO SOMETHING
  // alert(JSON.stringify(item))
  this.showList = false      
  this.placeid = item.place_id
  this.autocomplete.input = item.description
}


//lET'S BE CLEAN! THIS WILL JUST CLEAN THE LIST WHEN WE CLOSE THE SEARCH BAR.
ClearAutocomplete(){
  this.autocompleteItems = []
  this.autocomplete.input = ''
}

//sIMPLE EXAMPLE TO OPEN AN URL WITH THE PLACEID AS PARAMETER.
GoTo(){
  return window.location.href = 'https://www.google.com/maps/search/?api=1&query=Google&query_place_id='+this.placeid;
}

  async presentToast() {
    const toast = await this.toastController.create({
      message: 'Your order has been placed.',
      duration: 2000
    });
    toast.present();
  }

  placeOrder(){
    if(localStorage.getItem('token') == undefined || localStorage.getItem('token') == null || localStorage.getItem('token') == 'null' || localStorage.getItem('token') == ''){
      localStorage.setItem('previouspage',"shipping")
      this.router.navigate(['/login'])
    }
    else{
      if(this.selectedMethod == "card"){
        if(this.radioGroup.value != undefined && this.radioGroup.value != null && this.radioGroup.value != 'null' && this.radioGroup.value != ''){
          localStorage.setItem("selectedAddress",this.radioGroup.value)
          //localStorage.setItem("delivery_charge",this.showDeliveryMessage.delivery_charge)
          this.router.navigate(['/card-payment'])
        }
        else{
          this.alert.presentAlert('Alert','','Please select the shipping address')
        }
      }
      else if(this.selectedMethod == "cod"){
        this.priceDetails = JSON.parse(localStorage.getItem("priceDetails"))
        if(this.radioGroup.value != undefined && this.radioGroup.value != null && this.radioGroup.value != 'null' && this.radioGroup.value != ''){
          let requestData:any = {
            "device_token": localStorage.getItem("uuid"),
            "order": JSON.parse(localStorage.getItem("order_id")),
            "delivery_address": JSON.parse(this.radioGroup.value),
            "grant_total": JSON.parse(this.priceDetails.grand_total),
            "sub_total": JSON.parse(this.priceDetails.sub_total),
            "discount": JSON.parse(this.priceDetails.discount),
            "discount_percent": JSON.parse(this.priceDetails.discount_percent),
            "discount_percentage": this.priceDetails.discount_percentage,
            "payment_type": this.payementTypeId,
            "driver_tips": JSON.parse(this.priceDetails.tip),
            "delivery_charge": JSON.parse(localStorage.getItem('delivery-charge') || '0'),
            "order_comments": this.priceDetails.comments
          }
          this.api.placeOrder(requestData).subscribe((result:any) => {
            if(result.status == true){
              let orderId:any = 'Order Id : #'+result.data.id
              this.alert.presentAlert('Order Successful',orderId,"We'll let you know when your items are on the way.")
              let id = localStorage.getItem('store_id')
              this.router.navigate(['/home/'+id])
            }
          },(err)=>{
            console.log(err)
            this.alert.presentAlert('Order Unsuccessful','',"Please try again later")
            let id = localStorage.getItem('store_id')
            this.router.navigate(['/home/'+id])
          });
        }
        else{
          this.alert.presentAlert('Alert','','Please select the shipping address')
        }
      }
      else if(this.selectedMethod == "pickup"){
        this.priceDetails = JSON.parse(localStorage.getItem("priceDetails"))
        let requestData:any = {
          "device_token": localStorage.getItem("uuid"),
          "order": JSON.parse(localStorage.getItem("order_id")),
          "delivery_address": 16,
          "grant_total": JSON.parse(this.priceDetails.grand_total),
          "sub_total": JSON.parse(this.priceDetails.sub_total),
          "discount": JSON.parse(this.priceDetails.discount),
          "discount_percent": JSON.parse(this.priceDetails.discount_percent),
          "discount_percentage": this.priceDetails.discount_percentage,
          "payment_type": this.payementTypeId,
          "driver_tips": JSON.parse(this.priceDetails.tip),
          "delivery_charge": 0,
          "order_comments": this.priceDetails.comments
        }
        this.api.placeOrder(requestData).subscribe((result:any) => {
          if(result.status == true){
            let orderId:any = 'Order Id : #'+result.data.id
            this.alert.presentAlert('Order Successful',orderId,"We'll let you know when your items are on the way.")
            let id = localStorage.getItem('store_id')
            this.router.navigate(['/home/'+id])
          }
          else{
            this.alert.presentAlert('Order Unsuccessful','',result.message)
            let id = localStorage.getItem('store_id')
            this.router.navigate(['/home/'+id])
          }
        },(err)=>{
          console.log(err)
          this.alert.presentAlert('Order Unsuccessful','',"Please try again later")
          let id = localStorage.getItem('store_id')
          this.router.navigate(['/home/'+id])
        });
      }
      else {
        this.alert.presentAlert('Alert','','Please select the payment type')
      }
    }
  }

  addNewAddress(){
    if(localStorage.getItem('token') == undefined || localStorage.getItem('token') == null || localStorage.getItem('token') == 'null' || localStorage.getItem('token') == ''){
      localStorage.setItem('previouspage',"shipping")
      this.router.navigate(['/login'])
    }
    else{
      localStorage.setItem("from-ship-page","true")
      this.router.navigate(['/my-addresses'])
    }
  }

  ionViewWillEnter() {
    this.getAddressData()
  }

  getData(event:any){
    this.selectedMethod = event.detail.value
    console.log(this.selectedMethod)
    for(let i = 0;i< this.paymentTypes.length; i++){
      if(this.paymentTypes[i].payment_type == this.selectedMethod){
        this.payementTypeId = this.paymentTypes[i].id
      }
    }
    if(this.selectedMethod == 'pickup'){
      this.disableAddress = true
    }
    else {
      this.disableAddress = false
    }
  }

  payViaRazorPay(){
    this.razorPayService.payWithRazor()
  }

}
